import { Component, forwardRef, OnInit } from '@angular/core';
import { UntypedFormArray, FormBuilder } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { combineLatest, Subject } from 'rxjs';
import { EaEstimationFormService } from './ea-estimation-form.service';

@Component({
    selector: 'ea-estimation-form',
    templateUrl: './ea-estimation-form.component.html',
    styleUrls: ['./ea-estimation-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaEstimationFormComponent),
        },
    ],
    standalone: false
})
export class EaEstimationFormComponent
  extends PrFormAbstract
  implements OnInit
{
  /* connaissances = [
    { id: 'netMensuel', label: 'Net mensuel', suffix: '€/mois' },
    { id: 'netAnnuel', label: 'Net annuel', suffix: '€/an' },
    { id: 'brutMensuel', label: 'Brut mensuel', suffix: '€/mois' },
    { id: 'brutAnnuel', label: 'Brut annuel', suffix: '€/an' }
  ]; */

  // @ViewChild('amount', { static: false }) amountField: PrInputComponent;

  estateTypes = [];
  periodicityTypes = [];

  constructor(
    protected formConstructor: PrFormConstructor,
    public eaEstimationFormService: EaEstimationFormService,
    protected refDao: ReferenceDao,
  ) {
    super(formConstructor);
    this.eaEstimationFormService.generateSubject.subscribe(
      formGroup => (this.form = formGroup),
    );
  }

  ngOnInit() {
    if (!this.form.controls) this.initForm(this.entity);
    combineLatest([
      this.refDao.getEstateType(),
      this.refDao.getPeriodicityType(),
    ]).subscribe(([estateTypes, periodicityTypes]) => {
      this.estateTypes = estateTypes;
      this.periodicityTypes = periodicityTypes;
    });
  }

  get array(): UntypedFormArray {
    return this.form.get('array') as UntypedFormArray;
  }

  validate(fee) {
    // this.form
  }

  public generate(): any {
    return this.eaEstimationFormService.generate(this.entity);
  }

  public extract() {
    return this.eaEstimationFormService.extract(this.form);
  }

  onSubmit() {}

  getMonth(date: string) {
    let monthNumber = date.split('-')[1];
    let month: string = '';
    switch (monthNumber) {
      case '01':
        return (month = 'Janvier');
      case '02':
        return (month = 'Février');
      case '03':
        return (month = 'Mars');
      case '04':
        return (month = 'Avril');
      case '05':
        return (month = 'Mai');
      case '06':
        return (month = 'Juin');
      case '07':
        return (month = 'Juillet');
      case '08':
        return (month = 'Août');
      case '09':
        return (month = 'Septembre');
      case '10':
        return (month = 'Octobre');
      case '11':
        return (month = 'Novembre');
      case '12':
        return (month = 'Décembre');
    }
    return month;
  }

  doneSubject = new Subject<void>();
}
